module.exports = __webpack_public_path__ + "img/BC5B43_95170B_EEAC92_DB8C7C-256px.5b75eab6.png";